/* Base translations · Confirmations page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): confirmationsPage. */
export const I18N_BASE_CONFIRMATIONS = {
  en: {
    confirmationsPage: {
      noEngagement: "No engagement selected — pick one from the top to view confirmations.",
      title: "Confirmation Control",
      subtitle: "ISA 505 (External Confirmations) — one place to track every third-party balance confirmation across the engagement.",
      exportBtn: "Export XLSX",
      totalLabel: "Total",
      rowsInLabel: "{plural} in {cat}",
      addBtn: "Add confirmation",
      loading: "Loading…",
      empty: 'No confirmations yet — click "Add confirmation" to create one.',
      cols: {
        ref: "Ref #",
        counterparty: "Counterparty",
        type: "Type",
        balance: "Balance (client)",
        confirmed: "Confirmed",
        discrepancy: "Discrepancy",
        status: "Status",
        sent: "Sent",
        received: "Received",
        followup: "Follow-up",
        doc: "Doc",
        actions: "Actions",
      },
      openAttached: "Open attached confirmation",
      editBtn: "Edit",
      deleteBtn: "Delete",
      deletePromptTitle: "Delete this confirmation?",
      deletePromptBody: "{ref} · {counterparty}. This action is logged in the Audit Trail and cannot be undone.",
      cancelBtn: "Cancel",
      deleteConfirmBtn: "Delete",
      dialogEditTitle: "Edit {ref}",
      dialogNewTitle: "New confirmation",
      dialogDesc: "Enter or update third-party confirmation details. Every change is written to the Audit Trail.",
      fields: {
        category: "Category",
        counterparty: "Counterparty *",
        counterpartyAccount: "Counterparty account / GL ref",
        balanceClient: "Balance per client records",
        type: "Confirmation type (ISA 505)",
        status: "Status",
        dateSent: "Date sent",
        dateReceived: "Date received",
        confirmedBalance: "Confirmed balance (per counterparty)",
        followup: "Follow-up action",
        coverage: "Coverage",
        relationship: "Relationship",
        discrepancyNotes: "Discrepancy notes / reconciliation",
        altProc: "Alternative procedures performed (ISA 505)",
        attachment: "Confirmation attachment (received response)",
        supportingDocs: "Supporting documents",
      },
      placeholders: {
        counterparty: "Vendor / customer / RP / bank name",
        discrepancyNotes: "Explain any discrepancy between the client's records and the confirmed balance.",
        altProc: "If no reply: describe the alternative substantive procedures performed.",
        relationshipDash: "—",
      },
      viewAttached: "View attached",
      remove: "Remove",
      uploadingLabel: "Uploading…",
      uploadPdfImg: "Upload PDF / image",
      savingLabel: "Saving…",
      saveChanges: "Save changes",
      createBtn: "Create",
      toastDeleted: "Deleted",
      toastDeleteFailed: "Delete failed",
      toastCounterpartyReq: "Counterparty is required.",
      toastUpdated: "Updated",
      toastCreated: "Created",
      toastSaveFailed: "Save failed",
      toastAttachUploaded: "Attachment uploaded",
      toastAttachFailed: "Upload failed",
      categories: {
        ap: "Accounts Payable",
        ar: "Accounts Receivable",
        related_party: "Related Party",
        bank: "Bank",
        other: "Other",
      },
      statuses: {
        "Not Sent": "Not Sent",
        "Sent": "Sent",
        "Received – Agreed": "Received – Agreed",
        "Received – Discrepancy": "Received – Discrepancy",
        "No Reply": "No Reply",
        "Second Request Sent": "Second Request Sent",
      },
      types: {
        Positive: "Positive",
        Negative: "Negative",
        Blank: "Blank",
      },
      followUps: {
        None: "None",
        "Send reminder": "Send reminder",
        "Escalate": "Escalate",
        "Alt. procedure": "Alt. procedure",
        "Waive": "Waive",
      },
      bankCoverage: {
        Balance: "Balance",
        Loans: "Loans",
        Overdraft: "Overdraft",
        Guarantees: "Guarantees",
        Signatories: "Signatories",
        "Undrawn Facilities": "Undrawn Facilities",
      },
      rpRelationships: {
        Parent: "Parent",
        Subsidiary: "Subsidiary",
        Associate: "Associate",
        "Key Management": "Key Management",
        "Common Control": "Common Control",
        Other: "Other",
      },
    },
  },
  ar: {
    confirmationsPage: {
      noEngagement: "لا توجد مهمة محددة — اختر واحدة من الأعلى لعرض التأكيدات.",
      title: "لوحة التأكيدات",
      subtitle: "ISA 505 (التأكيدات الخارجية) — مكان واحد لتتبع كل تأكيد رصيد من طرف ثالث عبر المهمة.",
      exportBtn: "تصدير XLSX",
      totalLabel: "الإجمالي",
      rowsInLabel: "{plural} في {cat}",
      addBtn: "إضافة تأكيد",
      loading: "جاري التحميل…",
      empty: 'لا توجد تأكيدات بعد — انقر على "إضافة تأكيد" لإنشاء واحد.',
      cols: {
        ref: "المرجع",
        counterparty: "الطرف المقابل",
        type: "النوع",
        balance: "الرصيد (العميل)",
        confirmed: "المؤكَّد",
        discrepancy: "الفارق",
        status: "الحالة",
        sent: "أُرسل",
        received: "استُلم",
        followup: "المتابعة",
        doc: "المستند",
        actions: "الإجراءات",
      },
      openAttached: "فتح التأكيد المرفق",
      editBtn: "تعديل",
      deleteBtn: "حذف",
      deletePromptTitle: "حذف هذا التأكيد؟",
      deletePromptBody: "{ref} · {counterparty}. هذا الإجراء مسجّل في سجل المراجعة ولا يمكن التراجع عنه.",
      cancelBtn: "إلغاء",
      deleteConfirmBtn: "حذف",
      dialogEditTitle: "تعديل {ref}",
      dialogNewTitle: "تأكيد جديد",
      dialogDesc: "أدخل أو حدّث تفاصيل التأكيد من طرف ثالث. يُكتب كل تغيير في سجل المراجعة.",
      fields: {
        category: "الفئة",
        counterparty: "الطرف المقابل *",
        counterpartyAccount: "حساب الطرف المقابل / مرجع الأستاذ",
        balanceClient: "الرصيد وفق سجلات العميل",
        type: "نوع التأكيد (ISA 505)",
        status: "الحالة",
        dateSent: "تاريخ الإرسال",
        dateReceived: "تاريخ الاستلام",
        confirmedBalance: "الرصيد المؤكد (وفق الطرف المقابل)",
        followup: "إجراء المتابعة",
        coverage: "التغطية",
        relationship: "العلاقة",
        discrepancyNotes: "ملاحظات الفارق / التسوية",
        altProc: "الإجراءات البديلة المنفذة (ISA 505)",
        attachment: "مرفق التأكيد (الرد المستلم)",
        supportingDocs: "المستندات الداعمة",
      },
      placeholders: {
        counterparty: "اسم المورّد / العميل / الطرف ذي العلاقة / البنك",
        discrepancyNotes: "اشرح أي فارق بين سجلات العميل والرصيد المؤكَّد.",
        altProc: "إذا لم يرد ردّ: وصف الإجراءات الجوهرية البديلة التي أُجريت.",
        relationshipDash: "—",
      },
      viewAttached: "عرض المرفق",
      remove: "إزالة",
      uploadingLabel: "جاري الرفع…",
      uploadPdfImg: "رفع PDF / صورة",
      savingLabel: "جاري الحفظ…",
      saveChanges: "حفظ التغييرات",
      createBtn: "إنشاء",
      toastDeleted: "تم الحذف",
      toastDeleteFailed: "فشل الحذف",
      toastCounterpartyReq: "الطرف المقابل مطلوب.",
      toastUpdated: "تم التحديث",
      toastCreated: "تم الإنشاء",
      toastSaveFailed: "فشل الحفظ",
      toastAttachUploaded: "تم رفع المرفق",
      toastAttachFailed: "فشل الرفع",
      categories: {
        ap: "الدائنون",
        ar: "المدينون",
        related_party: "طرف ذو علاقة",
        bank: "بنك",
        other: "أخرى",
      },
      statuses: {
        "Not Sent": "لم يُرسل",
        "Sent": "أُرسل",
        "Received – Agreed": "استُلم — متطابق",
        "Received – Discrepancy": "استُلم — به فارق",
        "No Reply": "لا يوجد ردّ",
        "Second Request Sent": "أُرسل الطلب الثاني",
      },
      types: {
        Positive: "إيجابي",
        Negative: "سلبي",
        Blank: "فارغ",
      },
      followUps: {
        None: "لا شيء",
        "Send reminder": "إرسال تذكير",
        "Escalate": "تصعيد",
        "Alt. procedure": "إجراء بديل",
        "Waive": "إعفاء",
      },
      bankCoverage: {
        Balance: "الرصيد",
        Loans: "القروض",
        Overdraft: "السحب على المكشوف",
        Guarantees: "الضمانات",
        Signatories: "المفوضون بالتوقيع",
        "Undrawn Facilities": "التسهيلات غير المستخدمة",
      },
      rpRelationships: {
        Parent: "شركة أم",
        Subsidiary: "شركة تابعة",
        Associate: "شركة زميلة",
        "Key Management": "الإدارة العليا",
        "Common Control": "سيطرة مشتركة",
        Other: "أخرى",
      },
    },
  },
};

export default I18N_BASE_CONFIRMATIONS;
